<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-lg-3 col-md-3 col-sm-3"  [hidden]='true'>
      <div class="relative flmid">
        <div class="flgrow">
          <div class="input-group">
            <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
            [(ngModel)]="pService.searchTerm" autocomplete="off" />
            <div class="input-group-append">
              <button type="button" class="btn btn-primary">
                <em class="fa fa-search"></em>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="col-lg-2 col-md-3 col-sm-3 pl-4" *ngIf="dealerList && dealerList.length > 0">
      <div class="relative flmid">
        <div class="flgrow">
          <app-dealer-searchbox-dropdown [dealerList]="dealerList"   [selectedDealer]="selectedDealerId"
          ngDefaultControl name="dealerDropdown"
            (onSelectDealer)="onDealerSelected($event)" placeholder="Search Dealer">
          </app-dealer-searchbox-dropdown>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-3" *ngIf="partsList && partsList.length > 1">
      <div class="relative flmid">
        <div class="flgrow">
          <ng-select placeholder="{{ 'lblSelectPartNumber' | translate }}" [(ngModel)]="partSelected"
            (ngModelChange)="onChange($event)" style="max-width: 275px;">
            <ng-option *ngFor="let category of partsList" [value]="category.id">
              {{category.partNumber}}</ng-option>
          </ng-select>
        </div>
      </div>


    </div>
    <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
      <button type="button" type="reset" class="add-button btn btn-primary" aria-label="Center Align" translate
        (click)="onAdd()">lblAddDealerParts</button>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex">
          <h4 class="card-title" translate>lblAvailableParts</h4>

        </div>
        <div class="table-responsive">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width:55px" scope="col">#</th>
                <th scope="col" sortable="dealerName" (sort)="onSort($event)" translate>lblDealerName</th>
                <th scope="col" sortable="partNumber" (sort)="onSort($event)" translate>lblPartNumber</th>
                <th scope="col" translate [hidden]="true">lblConvertToPartNumber</th>
                <th scope="col" translate>lblDescription</th>
                <th scope="col" class="text-right" sortable="quantity" (sort)="onSort($event)" translate>lblTotalQuantity</th>
                <th scope="col" class="text-right" sortable="remainingQuantity" (sort)="onSort($event)" translate>lblRemainingQuantity</th>
                <th scope="col" class="text-right" sortable="unitPrice" (sort)="onSort($event)" translate>
                  lblUnitPrice</th>
                <th scope="col" class="text-center" sortable="isActive" (sort)="onSort($event)" translate>
                  lblActive</th>
                <th style="width:75px" scope="col" class="text-center" translate>lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="dealerPartDetails?.length>0; else load_else">
                <tr *ngFor="let parts of dealerPartDetails; let i=index">
                  <td>{{ parts.rowNumber }}</td>
                  <td>
                    <ngb-highlight [result]="parts.dealerName" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="parts.partNumber" [term]="pService.searchTerm"></ngb-highlight>
                  </td>

                  <td [hidden]="true">
                    <ngb-highlight [result]="parts.convertToPartNumber" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="parts.description" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>

                  <td class="text-right">
                    <ngb-highlight [result]="parts.quantity" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>
                  <td class="text-right">
                    <ngb-highlight [result]="parts.remainingQuantity" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>
                  <td class="text-right">
                    <ngb-highlight [result]="parts.unitPrice| number:'1.2-2'"
                      [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>
                  <td class="text-center">
                    <em class="fas" [ngClass]="{'fa-check': parts.isActive, 'fa-close': !parts.isActive}"></em>
                  </td>
                  <td class="nowrap text-center">
                    <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert"
                      (click)="editPartsDetails(parts.id)" *ngIf="userRoleRightsDetails.canEdit">
                      <em class="fas fa-pencil-alt fa-lg"></em>
                    </a>


                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>

            </tbody>
          </table>

        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between">
              <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                [pageSize]="pService.pageSize" [maxSize]="3">
              </ngb-pagination>
              <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                </option>
              </select>
            </div>
            <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>

</div>
